import { render, staticRenderFns } from "./WorkflowParameterBase.vue?vue&type=template&id=138fbff7&scoped=true&"
import script from "./WorkflowParameterBase.vue?vue&type=script&lang=js&"
export * from "./WorkflowParameterBase.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowParameterBase.vue?vue&type=style&index=0&id=138fbff7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138fbff7",
  null
  
)

export default component.exports